import React, { useEffect, useState } from 'react';
import { useDelayedLoading } from '../hooks/useDelayedLoading';
import { useNavigate } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import {
  evenementSelectRedux,
  evenementsRedux,
} from '../redux/evenementsServices';
import { pagesContent, refreshToken } from '../redux/profilService';
import EventSelectionLanding from '../components/EventSelectionLanding';
import ErrorPopup from '../components/ErrorPopup';
import textConnect from '../textConnect.json';
const Main = () => {
  const Evenements = useSelector(state => state.evenements.evenements);
  const userToken = useSelector(state => state.user.access);
  const refresh_token = useSelector(state => state.user.refresh);
  const monProfil = useSelector(state => state.profil.profil);

  const [netStatus, setNetStatus] = useState(() => {
    if (navigator.onLine) {
      console.log('Connected to network.');
      return true;
    } else {
      return false;
    }
  });

  useEffect(() => {
    window.ononline = e => {
      console.log('Connected to network.');
      setNetStatus(true);
    };
    window.onoffline = e => {
      console.log('Network connection lost.');
      setNetStatus(false);
    };
  }, [netStatus]);

  let dispatch = useDispatch();

  // console.log(Evenements.length)

  const navigationPage = useNavigate();
  const contenusBO = useSelector(state => state.profil.contenusTexte);

  const [openError, setOpenError] = useState(false);
  const [msgError, setMsgError] = useState('');

  const closeErrorHandle = () => {
    setOpenError(false);
  };

  const [loading, setLoading] = useState(true);
  const showLoading = useDelayedLoading(loading, 500);

  // const texteIntroEvents = useSelector(state => state.profil.contenusTexte.message_introduction_event)

  const selectEvent = (token, id, plan) => {
    setLoading(true);
    evenementSelectRedux(token, id)
      .then(reponse => {
        dispatch({
          type: 'evenements/addEvenementSelect',
          payload: reponse.data,
        });

        dispatch({
          type: 'evenements/addPlan',
          payload: plan,
        });
        navigationPage('/dashboard/' + id);
        setLoading(false);
      })
      .catch(erreur => {
        setLoading(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });
              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });
              console.log('token refresh...');
              selectEvent(token, id);
            });
          }
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
      });
  };

  useEffect(() => {
    dispatch({
      type: 'Profil/addChemin',
      payload: [{ url: '/', nom: 'Accueil' }],
    });
    dispatch({
      type: 'evenements/addEvenementSelect',
      payload: '',
    });
    pagesContent()
      .then(reponse => {
        dispatch({
          type: 'Profil/addTextContent',
          payload: reponse.data,
        });
        evenementsRedux(userToken)
          .then(response => {
            dispatch({
              type: 'evenements/addEvenements',
              payload: response.data,
            });
            setLoading(false);
          })
          .catch(erreur => {
            setLoading(false);
            if (!netStatus) {
              setMsgError(textConnect.internet);
              setOpenError(true);
            }
            if (erreur.response) {
              if (erreur.response.status !== 401) {
                setMsgError(textConnect.error);
                setOpenError(true);
              }
            }
          });
      })
      .catch(erreur => {
        setLoading(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });
              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });
              console.log('token refresh...');
            });
          }
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <EventSelectionLanding
      events={Evenements}
      loading={showLoading}
      onSelect={event => selectEvent(userToken, event.id, event.plan)}
      beforeNavigation={
        <ErrorPopup message={msgError} open={openError} close={() => closeErrorHandle()} />
      }
      navigationProps={{
        button: false,
        photo: monProfil.photo_path,
        retour: '',
        titre: (
          <div
            dangerouslySetInnerHTML={{
              __html: contenusBO.message_introduction_event,
            }}
          />
        ),
        menus: true,
      }}
    />
  );
};

export default Main;
